import VisuallyHidden from '@/components/VisuallyHidden';

import type {
  GraphEvent,
  ArrowEventType,
  BlockEventType,
} from './ClientServerGraph.types';

export default function TextFallback({
  events,
}: {
  events: Array<GraphEvent>;
}) {
  return (
    <VisuallyHidden as="div">
      <p>
        This is a data visualization which shows a sequence of events
        between client and server. Each event is represented here as a
        list item.
      </p>
      <ol>
        {events.map((event) =>
          isArrowEvent(event) ? (
            <ArrowEvent key={event.key} event={event} />
          ) : (
            <BlockEvent key={event.key} event={event} />
          )
        )}
      </ol>
    </VisuallyHidden>
  );
}

function ArrowEvent({ event }: { event: ArrowEventType }) {
  return (
    <li>
      {event.from === 'server'
        ? 'Response from server'
        : 'Request to server'}
      . Duration: {event.duration} units of time.
    </li>
  );
}

function BlockEvent({ event }: { event: BlockEventType }) {
  return (
    <li>
      "{event.children}" on {event.track}. Duration:{' '}
      {event.duration === 1 ? '1 unit' : `${event.duration} units`} of
      time.
    </li>
  );
}

const isArrowEvent = (event: GraphEvent): event is ArrowEventType =>
  event.type === 'arrow';
